import { useMemo } from "react";

import { SearchOverviewTexts } from "../../texts";
import GenericWidgetTable from "../GenericWidgetTable/GenericWidgetTable";

import useSearchTrafficTable from "./hooks/useSearchTrafficTable";
import { getSearchTrafficColumns } from "./tableColumns";

const SearchTrafficTable = () => {
    const { data, isLoading, isError } = useSearchTrafficTable();
    const columnConfig = useMemo(
        () => (data.length > 0 && !isLoading ? getSearchTrafficColumns() : []),
        [data, isLoading],
    );
    return (
        <GenericWidgetTable
            data-automation="search-overview-search-traffic-table"
            tableProps={{ data, isLoading, columnConfig }}
            title={SearchOverviewTexts.searchTrafficTitle}
            isError={isError}
            tooltip={SearchOverviewTexts.searchTrafficTooltip}
        />
    );
};

export default SearchTrafficTable;
